// Step 25 — attention chips for the Command Center.
//
// One chip per deterministic signal from `commandAttentionFlags`
// (which composes Step 24's execution flags + unread notifications +
// snapshot-count activity). Never a synthesized score.

import { commandAttentionFlags } from "./helpers";

export default function AICommandAttentionChips({
  actions,
  contracts,
  situation,
  snapshots,
  notifications,
  now,
}) {
  const flags = commandAttentionFlags({
    actions, contracts, situation, snapshots, notifications, now,
  });
  if (flags.length === 0) return null;
  return (
    <div className="qai-command-attention-chips">
      {flags.map((f) => (
        <span
          key={f.kind}
          className="qai-command-attention-chip"
          data-severity={f.severity}
          title={f.title}
        >
          {f.label}
        </span>
      ))}
    </div>
  );
}
